import useService from '@modules/ServiceModule/useService';

const UsersPanel = () => {
  const { users } = useService();
  return (
    <div>
      <pre>{JSON.stringify(users, undefined, 2)}</pre>
    </div>
  );
};

export default UsersPanel;
